var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0613 3C19.4896 3 19.8368 3.34721 19.8368 3.77551V13.1794C21.1747 13.5237 22.1633 14.7382 22.1633 16.1837C22.1633 17.6291 21.1747 18.8436 19.8368 19.188V21.2245C19.8368 21.6528 19.4896 22 19.0613 22C18.633 22 18.2858 21.6528 18.2858 21.2245V19.188C16.9478 18.8436 15.9592 17.6291 15.9592 16.1837C15.9592 14.7382 16.9478 13.5237 18.2858 13.1794V3.77551C18.2858 3.34721 18.633 3 19.0613 3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0815 3C12.5098 3 12.857 3.34721 12.857 3.77551V5.42426C14.195 5.76862 15.1836 6.98314 15.1836 8.42857C15.1836 9.874 14.195 11.0885 12.857 11.4329V21.2245C12.857 21.6528 12.5098 22 12.0815 22C11.6532 22 11.306 21.6528 11.306 21.2245V11.4329C9.96809 11.0885 8.97949 9.874 8.97949 8.42857C8.97949 6.98314 9.96809 5.76862 11.306 5.42426V3.77551C11.306 3.34721 11.6532 3 12.0815 3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.10204 3C5.53034 3 5.87755 3.34721 5.87755 3.77551V10.8528C7.21548 11.1972 8.20408 12.4117 8.20408 13.8571C8.20408 15.3026 7.21548 16.5171 5.87755 16.8615V21.2245C5.87755 21.6528 5.53034 22 5.10204 22C4.67374 22 4.32653 21.6528 4.32653 21.2245V16.8615C2.9886 16.5171 2 15.3026 2 13.8571C2 12.4117 2.9886 11.1972 4.32653 10.8528V3.77551C4.32653 3.34721 4.67374 3 5.10204 3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsFilled);
export default __webpack_public_path__ + "static/media/settings-filled.92d3912ec4a9e5040c15839900d14cf1.svg";
export { ForwardRef as ReactComponent };